import { type Thing } from 'schema-dts'
import { type SeoSchemaImage } from '@/features/shared/utils/seo/seoConfig'

// Checkout https://schema.org/ for more details on the schema types used in this file
export type SEOHeadProps = {
  title: string
  description: string
  canonicalUrl: string
  doNotFollow?: boolean
  doNotIndex?: boolean
  image?: SeoSchemaImage
  breadcrumbs?: {
    '@type': string
    '@context': string
    itemListElement: {
      '@type': string
      position: number
      name: string
      item: string
    }[]
  }
  socialMediaSchema?: {
    title: string
    description: string
    url: string
    image: SeoSchemaImage
    type?: string // e.g., 'website', 'article', etc.
    card?: string // For Twitter, e.g., 'summary_large_image'
    price?: string // For product pages, e.g., '25.00'
  }

  pageTypeSchema?: {
    '@context': string
    '@type': string | string[]
    name: string
    description: string
    url: string
    image?: SeoSchemaImage
    mainEntityOfPage?: {
      '@type': string
      '@id': string
    }
    brand?: {
      '@type': string
      name: string
      logo?: {
        '@type': string
        url: string
        width?: number
        height?: number
      }
    }
    aggregateRating?: {
      '@type': string
      ratingValue: number
      ratingCount: number
    }
    offers?: {
      '@type': string
      priceCurrency: string
      price: string
      itemCondition: string
      availability: string
      url?: string
      seller?: {
        '@type': string
        name: string
      }
    }
    mainEntity?: MainEntity | MainEntity[]
  }
  additionalSchemas?: Thing[]
}

export type MainEntity = {
  '@type': string
  itemListElement?: {
    '@type': string
    name: string
    url: string
    logo?: string
  }[]
}

export const enum SEO_PAGE_TYPE {
  PRODUCT = 'Product',
  ARTICLE = 'Article',
  LOCAL_BUSINESS = 'LocalBusiness',
  FAQ_PAGE = 'FAQPage',
  EVENT = 'Event',
  WEB_PAGE = 'WebPage',
  COLLECTION_PAGE = 'CollectionPage',
  SEARCH_RESULTS_PAGE = 'SearchResultsPage',
}
